// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"127":"c7951dd3313fe031","888":"24b6f3a334b6f1fc"}[chunkId] + ".css";
};